import type { CSSProperties, ReactElement } from 'react';
import { CtextinputErrorText } from './CtextinputErrorText';

interface CtextinputErrorSlotProps {
  errorText: string | null;
  style: CSSProperties;
}

export function CtextinputErrorSlot({
  errorText,
  style,
}: CtextinputErrorSlotProps): ReactElement | null {
  if (!errorText) {
    return null;
  }

  return <CtextinputErrorText errorText={errorText} style={style} />;
}
